module.exports = __webpack_public_path__ + "static/media/3rlogo.1949e72c.png";